export type MerchantBadgeLevel = "NONE" | "VERIFIED" | "TRUSTED" | "PREMIUM" | string;

export type MerchantVerificationFilter = "" | "verified" | "pending";

export type MerchantStatus = "pending" | "verified" | "suspended";

/** Mirrors Backend's MerchantListItemForAdminResponse wire shape. */
export interface MerchantListItem {
  id: string;
  organization_id: string;
  business_name: string | null;
  logo_url: string | null;
  email: string | null;
  phone: string | null;
  category_id: string | null;
  category_name: string | null;
  partner_type: string | null;
  verification_status: boolean;
  badge_level: string;
  requires_reverification: boolean;
  last_reviewed_at: string | null;
  user_status: string;
  created_at: string;
}

export interface MerchantSocialLinks {
  website?: string | null;
  facebook?: string | null;
  instagram?: string | null;
  twitter?: string | null;
}

export interface MerchantLocation {
  id?: string;
  address?: string | null;
  city?: string | null;
  latitude?: number | null;
  longitude?: number | null;
}

export interface MerchantBusinessHour {
  day_of_week?: string | null;
  open_time?: string | null;
  close_time?: string | null;
}

/** Mirrors Backend's MerchantDetailForAdminResponse wire shape. */
export interface MerchantDetail extends MerchantListItem {
  first_name: string | null;
  last_name: string | null;
  description: string | null;
  short_intro: string | null;
  business_url: string | null;
  review_note: string | null;
  social_links: MerchantSocialLinks | null;
  locations: MerchantLocation[];
  business_hours: MerchantBusinessHour[];
  plan_code: string | null;
  plan_name: string | null;
  subscription_state: string | null;
}

/** Mirrors Backend's MerchantStatisticsForAdminResponse wire shape. */
export interface MerchantStatistics {
  total_merchants: number;
  pending_merchants: number;
  verified_merchants: number;
  suspended_merchants: number;
}

/** Mirrors Backend's MerchantListForAdminRequest query contract. */
export interface GetMerchantListRequest {
  keyword?: string;
  category_id?: string;
  verification_status?: boolean;
  badge_level?: string;
  index: number;
  size: number;
  sort_key?: string;
  sort_direction?: "asc" | "desc";
}

/** Mirrors Backend's UpdateMerchantAdminRequest body contract. */
export interface UpdateMerchantAdminRequest {
  business_name?: string;
  short_intro?: string;
  description?: string;
  business_url?: string;
  business_category_id?: string;
  partner_type?: string;
  phone?: string;
}

/** Mirrors Backend's SuspendMerchantRequest body contract. */
export interface SuspendMerchantRequest {
  reason: string;
}

/**
 * Presentation-only filter state for the portal merchant-list UI.
 * The owning hook translates this into GetMerchantListRequest;
 * the API layer never maps UI state.
 */
export interface MerchantFilters {
  keyword: string;
  category_id: string;
  verification_status: MerchantVerificationFilter;
  badge_level: string;
}

export const defaultMerchantFilter: MerchantFilters = {
  keyword: "",
  category_id: "",
  verification_status: "",
  badge_level: "",
};
